import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Container, Label } from "./styles";
import { Radio } from "../radio";
import { StepComponentProps } from "../steps";
import { useMediaQuery } from "~/hooks/useMediaQuery";

const TOOLS_ARRAY = [
  {
    id: "product-database",
    label: "onboarding.option_product_database",
  },
  {
    id: "product-portfolio",
    label: "onboarding.option_product_portfolio",
  },
  {
    id: "competitor-research",
    label: "onboarding.option_competitor_research",
  },
  {
    id: "ad-spy-tool",
    label: "onboarding.option_ad_spy_tool",
  },
  {
    id: "sales-tracker",
    label: "onboarding.option_sales_tracker",
  },
  {
    id: "all-of-them",
    label: "onboarding.option_all_of_them",
  },
];

type ToolSelectionProps = StepComponentProps & {};

export const ToolSelection = ({
  onboardingChoices,
  setOnboardingChoices,
}: ToolSelectionProps) => {
  const { t } = useTranslation();
  const isAboveMobile = useMediaQuery("mobileL");

  const selectedTools = onboardingChoices?.selectedTool || [];
  const allToolIds = TOOLS_ARRAY.filter(
    (tool) => tool.id !== "all-of-them"
  ).map((tool) => tool.id);

  const handleSelectTool = useCallback(
    (toolId: string) => {
      if (toolId === "all-of-them") {
        setOnboardingChoices((prev) => {
          const currentTools = prev?.selectedTool || [];
          const isAllSelected = currentTools.includes("all-of-them");

          if (isAllSelected) {
            return {
              ...prev,
              selectedTool: [],
            };
          } else {
            return {
              ...prev,
              selectedTool: [...allToolIds, "all-of-them"],
            };
          }
        });
      } else {
        setOnboardingChoices((prev) => {
          const currentTools = prev?.selectedTool || [];
          const alreadySelected = currentTools.includes(toolId);

          let updatedSelection;
          if (alreadySelected) {
            updatedSelection = currentTools.filter(
              (id) => id !== toolId && id !== "all-of-them"
            );
          } else {
            const newSelection = [
              ...currentTools.filter((id) => id !== "all-of-them"),
              toolId,
            ];
            const allSelected = allToolIds.every((id) =>
              newSelection.includes(id)
            );

            if (allSelected) {
              updatedSelection = [...newSelection, "all-of-them"];
            } else {
              updatedSelection = newSelection;
            }
          }

          return {
            ...prev,
            selectedTool: updatedSelection,
          };
        });
      }
    },
    [allToolIds]
  );

  return (
    <Container data-testid="tool-selection">
      {TOOLS_ARRAY.map((tool) => {
        const { id: toolId, label } = tool;
        const checked = selectedTools.includes(toolId);

        return (
          <Radio
            key={toolId}
            context="tool-selection"
            optionId={toolId}
            checked={checked}
            isFullWidth={!isAboveMobile}
            label={<Label checked={checked}>{t(label)}</Label>}
            useCheckbox={true}
            changeSeletedOption={handleSelectTool}
          />
        );
      })}
    </Container>
  );
};
